// extracted by mini-css-extract-plugin
export default {"formBox":"FormStudent_formBox__6TdVb","formGrid":"FormStudent_formGrid__-Sh3X","formGroup":"FormStudent_formGroup__CURz7"};